import WisdomNavbar from "components/navbars/WisdomNabvar";
import SystemCard from "components/SystemCard";
import { getWisdomAdminEmployeePanel } from "constants/constants";
import { useLanguage } from "context/LanguageContext";
import { useNavigate } from "react-router-dom";

const WisdomAdminEmployee = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const panels = getWisdomAdminEmployeePanel(language);
    
    return (
        <>
            <WisdomNavbar />
            <div className="grid grid-cols-2 gap-4 mb-10 max-w-7xl mx-auto">
                {panels.map(panel => (
                    <SystemCard
                        key={panel.id}
                        openPopup={() => navigate(panel.path)}
                        available={panel.available}
                        path={panel.path}
                        color={panel.color}
                        iconType="awesome"
                        icon={panel.icon}
                        title={panel.title}
                        subtitle={panel.subtitle}
                    />
                ))}
            </div>
        </>
    )
};

export default WisdomAdminEmployee;